<template>
      <!--定点投放 添加标签 对话框 -->

    <el-drawer title="添加标签" :visible.sync="show" :with-header="false" :before-close="closeDialog" size="600px">

        <!-- 基本信息表单 -->
        <div class="form-box">


            <template>

                <el-form ref="form" :model="submit_data" label-width="80px" style="height: 90vh; overflow-y: auto;">

                    <el-form-item label="标签名字:" label-width='120px'>
                       <el-input v-model="submit_data.name" :placeholder="submit_rules.name.placeholder" style="width: 150px; margin-right:5px">
                        </el-input>
                    </el-form-item>

                </el-form>


                <!-- 对话框底部按钮 -->
                <div style="display: flex;justify-content: center">
                    <submitBtn @onSubmitDig="onSubmitDig" :data="submit_data" :rules="submit_rules"
                               :url="submit_url" :JSON_Boolean="false"></submitBtn>
                    <el-button @click="closeDialog">关闭</el-button>

                </div>

            </template>


        </div>


    </el-drawer>
</template>

<script>

    var _this;
    export default {
        props: {
            'isShow': Boolean
        },
        watch: {

            isShow(newData, oldData) {

                _this.show = true;

            }
        },
        data() {
            return {


                show: false,
              

                submit_url: '/promotion/addPromotionLabel',
                // 表单数据
                submit_data: {
                    name: '',
                },

                submit_rules: {

                    name: {
                        placeholder: '标签名称',
                        rules: {
                            required: true,
                            message: '标签名称错误',
                            regulation: 'gt_str',
                            rulesData: 0
                        }
                    },
                        
                 
                },

            };
        },
        created() {

            _this = this;

        },
        methods: {


            // 关闭方法
            closeDialog() {
                _this.show = false;
                _this.submit_data= {
                    name: '',
                }
             

            },


            // 提交
            onSubmitDig() {
                _this.$emit('onSubmit');
                _this.closeDialog();
            }
        }
    };
</script>

<style scoped>
    .form-box {
        padding: 20px;
        box-sizing: border-box;
        margin-right: 0;
        width: 100%;
    }

    .avatar-uploader .el-upload {
        border: 1px dashed #d9d9d9;
        border-radius: 6px;
        cursor: pointer;
        position: relative;
        overflow: hidden;
    }

    .avatar-uploader .el-upload:hover {
        border-color: #409EFF;
    }

    .avatar-uploader-icon {
        font-size: 28px;
        color: #8c939d;
        width: 178px;
        height: 178px;
        line-height: 178px;
        text-align: center;
    }

    .avatar {
        width: 178px;
        height: 178px;
        display: block;
    }

    .el-form-second {
        display: flex;
        flex-wrap: wrap;
        justify-content: space-around;
    }

    .avatar-uploader {
        width: 100px;
        height: 100px;
    }
    .item-wrap{
        margin-bottom: 10px;
    }
</style>
